var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutClearedStampEarly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Early graduation completion stamp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Purple circular stamp with a graduation cap, lightning bolt, and large completion check.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#5B4FD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 112,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 99,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 62 128 44l46 18-46 19-46-19Z",
    fill: "#5B4FD8",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 72v14c17 14 47 14 64 0V72",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 65v20",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 92,
    r: 5,
    fill: "#5B4FD8",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184 48-12 21h11l-8 19 23-27h-12l8-13Z",
    fill: "#5B4FD8",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68 139 41 41 79-79",
    strokeWidth: 18,
    transform: "translate(38.4 38.4) scale(.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutClearedStampEarly);
export default __webpack_public_path__ + "static/media/workout_cleared_stamp_early.94e385c95954a769e2aef0856c8079ed.svg";
export { ForwardRef as ReactComponent };